export type InventoryFilter = 'available' | 'sold' | 'withdrawn';

export const DEFAULT_INVENTORY_FILTER: InventoryFilter = 'available';

export const INVENTORY_FILTERS: InventoryFilter[] = ['available', 'sold', 'withdrawn'];

export function parseInventoryFilter(raw: string | undefined | null): InventoryFilter {
  return raw === 'available' || raw === 'sold' || raw === 'withdrawn' ? raw : DEFAULT_INVENTORY_FILTER;
}
